import { useSelector } from 'react-redux';

export default function useAppInfo() {
  return useSelector(({ appInfo }) => appInfo);
}
